import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { threeDigitsPrecisionHumanization } from '@/modules/shared/lib/humanization';
import { ProposalCardOutline } from './proposal-card-outline';
interface BudgetEstimateCardProps {
  totalBudget: number;
}
function BudgetEstimateCard(t0) {
  const $ = _c(15);
  const {
    totalBudget
  } = t0;
  let t1;
  if ($[0] !== totalBudget) {
    t1 = threeDigitsPrecisionHumanization(totalBudget);
    $[0] = totalBudget;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const humanizedBudget = t1;
  const t2 = humanizedBudget.suffix ? "items-end" : "items-baseline";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("flex justify-center gap-2", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== humanizedBudget.value) {
    t4 = <div className="text-3xl font-bold">{humanizedBudget.value}</div>;
    $[4] = humanizedBudget.value;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== humanizedBudget.suffix) {
    t5 = humanizedBudget.suffix && <div>{humanizedBudget.suffix}</div>;
    $[6] = humanizedBudget.suffix;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div>USD</div>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5) {
    t7 = <div className="text-foreground/50 text-left leading-4 uppercase">{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t7) {
    t8 = <ProposalCardOutline title="Budget Estimate" className="pb-6"><div className="flex h-full gap-2 text-center"><div className="flex flex-1 items-end justify-center"><div className={t3}>{t4}{t7}</div></div></div></ProposalCardOutline>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
export { BudgetEstimateCard };